import { useLayoutEffect } from 'react';
import type { Appearance } from '../state/app-data';
import { applyTheme, isDarkTheme } from './appearance';

const PHONE_DARK = '(prefers-color-scheme: dark)';

/**
 * DE: Thema auf `<html>` setzen und bei „wie am Telefon“ dem Telefon ohne Neuladen folgen.
 * EN: Set the theme on `<html>` and, for "as on the phone", follow the phone without a reload.
 */
export function useTheme(appearance: Appearance | undefined): void {
  useLayoutEffect(() => {
    const root = document.documentElement;
    // DE: Ältere Browser ohne matchMedia bleiben hell.
    // EN: Older browsers without matchMedia stay light.
    const phone = typeof window.matchMedia === 'function' ? window.matchMedia(PHONE_DARK) : null;
    const apply = () => applyTheme(root, isDarkTheme(appearance, phone?.matches ?? false));
    apply();
    if (!phone || (appearance !== undefined && appearance !== 'system')) return;
    phone.addEventListener('change', apply);
    return () => phone.removeEventListener('change', apply);
  }, [appearance]);
}
